// Gamification Redux Saga
import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall } from "../../utils/axios";
import * as actions from "./actions";

// ==================== PROFILE ====================

function* fetchGamificationProfile() {
    try {
        const result = yield call(AxiosCall, '/gamification/profile/me/');
        yield put(actions.fetchGamificationProfileSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchGamificationProfileFailure(e.message));
    }
}

function* updateGamificationPreferences(action) {
    try {
        const result = yield call(
            AxiosCall,
            '/gamification/profile/preferences/',
            'PATCH',
            action.payload
        );
        yield put(actions.updateGamificationPreferencesSuccess(result.data));
    } catch (e) {
        yield put(actions.updateGamificationPreferencesFailure(e.message));
    }
}

// ==================== XP ====================

function* fetchRecentXP() {
    try {
        const result = yield call(AxiosCall, '/gamification/profile/recent_xp/');
        yield put(actions.fetchRecentXPSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchRecentXPFailure(e.message));
    }
}

function* fetchXPSummary() {
    try {
        const result = yield call(AxiosCall, '/gamification/xp-history/summary/');
        yield put(actions.fetchXPSummarySuccess(result.data));
    } catch (e) {
        yield put(actions.fetchXPSummaryFailure(e.message));
    }
}

// ==================== ACHIEVEMENTS ====================

function* fetchAchievements() {
    try {
        const result = yield call(AxiosCall, '/gamification/achievements/');
        yield put(actions.fetchAchievementsSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchAchievementsFailure(e.message));
    }
}

function* fetchUnlockedAchievements() {
    try {
        const result = yield call(AxiosCall, '/gamification/achievements/unlocked/');
        yield put(actions.fetchUnlockedAchievementsSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchUnlockedAchievementsFailure(e.message));
    }
}

// ==================== CHALLENGES ====================

function* fetchChallenges() {
    try {
        const result = yield call(AxiosCall, '/gamification/challenges/');
        yield put(actions.fetchChallengesSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchChallengesFailure(e.message));
    }
}

function* joinChallenge(action) {
    try {
        const { challengeId } = action.payload;
        const result = yield call(
            AxiosCall,
            `/gamification/challenges/${challengeId}/join/`,
            'POST'
        );
        yield put(actions.joinChallengeSuccess({
            challengeId,
            progress: result.data.progress,
        }));
        // Refresh challenges list
        yield put(actions.fetchChallengesRequest());
    } catch (e) {
        yield put(actions.joinChallengeFailure(e.message));
    }
}

// ==================== LEADERBOARDS ====================

function* fetchGlobalLeaderboard(action) {
    try {
        const { leaderboardType, limit, offset } = action.payload;
        const result = yield call(
            AxiosCall,
            `/gamification/leaderboards/global/${leaderboardType}/?limit=${limit}&offset=${offset}`
        );
        yield put(actions.fetchGlobalLeaderboardSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchGlobalLeaderboardFailure(e.message));
    }
}

function* fetchOrganizationLeaderboard(action) {
    try {
        const { orgShortId, leaderboardType } = action.payload;
        const result = yield call(
            AxiosCall,
            `/gamification/leaderboards/organization/${orgShortId}/?type=${leaderboardType}`
        );
        yield put(actions.fetchOrganizationLeaderboardSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchOrganizationLeaderboardFailure(e.message));
    }
}

// ==================== SKILL TREE ====================

function* fetchSkillTree() {
    try {
        const result = yield call(AxiosCall, '/gamification/skill-tree/');
        yield put(actions.fetchSkillTreeSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchSkillTreeFailure(e.message));
    }
}

// ==================== ROOT SAGA ====================

export default function* gamificationSaga() {
    yield all([
        // Profile
        takeLatest(actions.FETCH_GAMIFICATION_PROFILE.REQUEST, fetchGamificationProfile),
        takeLatest(actions.UPDATE_GAMIFICATION_PREFERENCES.REQUEST, updateGamificationPreferences),

        // XP
        takeLatest(actions.FETCH_RECENT_XP.REQUEST, fetchRecentXP),
        takeLatest(actions.FETCH_XP_SUMMARY.REQUEST, fetchXPSummary),

        // Achievements
        takeLatest(actions.FETCH_ACHIEVEMENTS.REQUEST, fetchAchievements),
        takeLatest(actions.FETCH_UNLOCKED_ACHIEVEMENTS.REQUEST, fetchUnlockedAchievements),

        // Challenges
        takeLatest(actions.FETCH_CHALLENGES.REQUEST, fetchChallenges),
        takeLatest(actions.JOIN_CHALLENGE.REQUEST, joinChallenge),

        // Leaderboards
        takeLatest(actions.FETCH_GLOBAL_LEADERBOARD.REQUEST, fetchGlobalLeaderboard),
        takeLatest(actions.FETCH_ORGANIZATION_LEADERBOARD.REQUEST, fetchOrganizationLeaderboard),

        // Skill Tree
        takeLatest(actions.FETCH_SKILL_TREE.REQUEST, fetchSkillTree),
    ]);
}
